import { SxProps, Theme } from '@mui/material/styles';

export const containerDpBannerAdsContenMainSX: SxProps<Theme> = {
	userSelect: 'none',
	display: 'flex',
	backgroundColor: '#FFF',
	height: '100%',
	position: 'relative',
	marginTop: '50px',
	// marginBottom: '50px',
};

type DpAlignVerticalType = 'flex-start' | 'center' | 'flex-end';
type DpAlignHorizontalType = 'flex-start' | 'center' | 'flex-end';
export const containerInfoDpBannerAdsContentMainSX = ({
	justifyContent,
	alignItems,
	heightContainer,
	backgroundTitle,
}: {
	isMobile?: boolean;
	justifyContent?: DpAlignVerticalType;
	alignItems?: DpAlignHorizontalType;
	heightContainer?: string;
	backgroundTitle?: boolean;
}): SxProps => ({
	bottom: 0,
	background: backgroundTitle
		? 'transparent linear-gradient(180deg, #00000000 0%, #00000055 34%, #00000069 100%) 0% 0% no-repeat padding-box'
		: 'none',
	opacity: 1,
	width: '100%',
	position: 'absolute',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: {
		xs: justifyContent,
		sm: justifyContent,
	},
	alignItems,
	height: heightContainer,
	p: {
		xs: '24px 20px 24px 20px',
		sm: '0 70px 0 70px',
	},
});
type DpAlignTextTitleType = 'start' | 'center' | 'end';

export const titleDpBannerAdsContentMainSX = ({
	widthTextTitle,
	alignText,
	colorText,
}: {
	isMobile?: boolean;
	widthTextTitle?: string;
	alignText?: DpAlignTextTitleType;
	colorText?: string;
}): SxProps => ({
	textAlign: alignText,
	width: widthTextTitle,
	lineHeight: '1',
	fontWeight: '800',
	fontSize: {
		xs: 'var(--font-size-xl)',
		sm: 'var(--font-size-display)',
	},
	color: colorText,
});
